import { CostosPlataformaService } from "../../generated/grpc/plataforma_costos_pb";
import { ServiceDeleteBase } from "../base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { CostoGanaderiaListService } from "./CostoGanaderiaListService";

/** Baja de tramos de DATA AG ganadería; la saca del listado en memoria. */
export class CostoGanaderiaDeleteService extends ServiceDeleteBase {
  static readonly instance = new CostoGanaderiaDeleteService();
  private constructor() { super(); }

  protected readonly cache = CostoGanaderiaListService.instance;

  /** gRPC-Web (`EliminarGanaderia`): baja lógica; `NotFoundError` si no existe. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(CostosPlataformaService).eliminarGanaderia({ id }));
  }
}
